import React from "react";
import "./tables.styles.scss";
import { valueConverter } from '../../util-functions/util-funtions'
const months = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC"
];

export default function YOYTable(props) {

  return (
    <table className='months-table'>

      <thead>
        <tr>
         <th className='tables-cell months-header-cell'>Year</th>
        {months.map((item,ind) => (
          <th className='tables-cell months-header-cell' key={ind}>{item}</th>
          ))
        }
        </tr>
      </thead>

      <tbody>

        {props.data ?
          props.data.map((item, index) => (

            <tr key={index} className='last-row'>
              <td className='tables-cell year-column'>{Object.keys(item)}</td>
              <td className='tables-cell'>{item[Object.keys(item)]? valueConverter(item[Object.keys(item)].Jan, 'yoy'): "NO"}</td>
              <td className='tables-cell'>{item[Object.keys(item)]? valueConverter(item[Object.keys(item)].Feb, 'yoy'): "NO"}</td>
              <td className='tables-cell'>{item[Object.keys(item)]? valueConverter(item[Object.keys(item)].Mar, 'yoy'): "NO"}</td>
              <td className='tables-cell'>{item[Object.keys(item)]? valueConverter(item[Object.keys(item)].Apr, 'yoy'): "NO"}</td>
              <td className='tables-cell'>{item[Object.keys(item)]? valueConverter(item[Object.keys(item)].May, 'yoy'): "NO"}</td>
              <td className='tables-cell'>{item[Object.keys(item)]? valueConverter(item[Object.keys(item)].Jun, 'yoy'): "NO"}</td>
              <td className='tables-cell'>{item[Object.keys(item)]? valueConverter(item[Object.keys(item)].Jul, 'yoy'): "NO"}</td>
              <td className='tables-cell'>{item[Object.keys(item)]? valueConverter(item[Object.keys(item)].Aug, 'yoy'): "NO"}</td>
              <td className='tables-cell'>{item[Object.keys(item)]? valueConverter(item[Object.keys(item)].Sep, 'yoy'): "NO"}</td>
              <td className='tables-cell'>{item[Object.keys(item)]? valueConverter(item[Object.keys(item)].Oct, 'yoy'): "NO"}</td>
              <td className='tables-cell'>{item[Object.keys(item)]? valueConverter(item[Object.keys(item)].Nov, 'yoy'): "NO"}</td>
              <td className='tables-cell'>{item[Object.keys(item)]? valueConverter(item[Object.keys(item)].Dec, 'yoy'): "NO"}</td>
            </tr>

          ))
          :
          null
        }

      </tbody>

    </table>
  )
}
